<template>
  <div class="pb-slider__marks-text" :style="this.mark.style ">{{ label }}</div>
</template>

<script>
export default {
  name: 'PbMarker',
  props: {
    mark: {
      type: [String, Object]
    }
  },
  computed: {
    label () {
      return typeof this.mark === 'string' ? this.mark : this.mark.label
    }
  }
}
</script>

<style>

</style>
